module.exports = __webpack_public_path__ + "static/sophia-5279d90fbab496d60977bdbaf0812f9a.png";